import { render } from "./InvoiceManagement.vue?vue&type=template&id=0208f654&scoped=true"
import script from "./InvoiceManagement.vue?vue&type=script&lang=js"
export * from "./InvoiceManagement.vue?vue&type=script&lang=js"

import "./InvoiceManagement.vue?vue&type=style&index=0&id=0208f654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0208f654"]])

export default __exports__